import firebase from 'firebase'
import { 
  saveCampaignContent, 
  getListOfCampaignContent,
  getDetailOfCampaignContent,
  changeStatusCampaignContent
} from '@/service/influencer/campaignContent'
import { 
  getAllCampaignFilesByUser, 
  uploadCampaignFile, 
  deleteCampaignFile 
} from '@/service/s3-bucket'

const state = {
  campaignContents: [],
  campaignContentDetail: {}
}

const getters = {
  campaignContentsStore: state => state.campaignContents,
  campaignContentDetailStore: state => state.campaignContentDetail,
}

const actions = {
  async getAllCampaignFilesByUserOnS3({commit}, {influencer, campaign}) {
    await getAllCampaignFilesByUser(influencer, campaign)
  },
  async deleteCampaignFileOnS3({commit}, {dirName, fileName}) {
    const response = await deleteCampaignFile(dirName, fileName)
    if (response.message == 'File Deleted') {
      commit('removeCampaignFile', dirName + '/' + fileName)
    }
    return response
  },
  async getListOfCampaignContent({commit}, campaign) {
    const response = await getListOfCampaignContent(campaign)
    commit('setCampaignContents', response.data.result)
  },
  async getDetailOfCampaignContent({commit}, contentId) {
    const response = await getDetailOfCampaignContent(contentId)
    commit('setCampaignContentDetail', response.data.result)
  },
  async uploadCampaignFile({dispatch}, {file, influencer, campaign}) {
    let response = false
    // Uploading on S3
    const responseS3 = await uploadCampaignFile(file, influencer, campaign)
    if (responseS3.key) {
      const campaignContent = {
        influencer: influencer,
        campaign: campaign,
        contentUrl: responseS3.key,
        usertoken: firebase.auth().currentUser.uid
      }          
      // Saving on HelloConvo API
      const responseAPI = await saveCampaignContent(campaignContent)  
      response = responseAPI.data.success
      if (response) {
        dispatch('getListOfCampaignContent', campaign)
      }
    }
    return response
  },
  async archiveCampaignContent({commit}, {contentId, influencerId}) {
    const data = {
      content: contentId,
      influencer: influencerId,
      status: 'archived',
      usertoken: firebase.auth().currentUser.uid
    }
    const response = await changeStatusCampaignContent(data)
    return response.data.success
  }
}

const mutations = {
  setCampaignContents(state, campaignContents) {
    state.campaignContents = campaignContents
  },
  setCampaignContentDetail(state, campaignContentDetail) {
    state.campaignContentDetail = campaignContentDetail
  },
  updateCampaignContentDetail(state, data) {
    state.campaignContentDetail.status = data.status
  },
  addCampaignContent(state, campaignContent) {
    state.campaignContents.push(campaignContent)
  },
  removeCampaignContent(state, contentId) {
    const item = state.campaignContents.find(item => item._id == contentId)
    const indexItem = state.campaignContents.indexOf(item)
    state.campaignContents.splice(indexItem, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}